import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { ClubApi } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { ClubAdressePage } from "./ClubAdressePage";
import { ClubAllowedSectionsPage } from "./ClubSections/ClubAllowedSectionsPage";
import { ClubAllowedBreedsPage } from "./ClubAllowedBreedsPage";
import { ClubFilePage } from "./ClubFilePage";
import { ClubJuryPage } from "./ClubJuryPage";
import { ClubDetailPage } from "./ClubDetails/ClubDetailPage";

export interface IClubItemPageProps {}

export const ClubItemPage: React.FunctionComponent<IClubItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const clubId = React.useMemo(() => +id, [id]);
  const history = useHistory();
  const breedGroupApi = useApiService(ClubApi);
  const [displayName, loading] = useApiEffect(() => breedGroupApi.getDisplayName(clubId), [clubId]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Clubs), route: ERoutes.club },
        { text: clubId > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="RabsClub"
        onChange={(newTabId) => history.push(`${ERoutes.club}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.club} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<ClubDetailPage clubId={clubId} editMode={state === "edit"} />}
        />
        <Tab
          id="adresse"
          title={t(ETLCodes.Addresses)}
          panel={<ClubAdressePage clubId={clubId} editMode={state === "edit"} />}
          disabled={+id <= 0}
        />
        <Tab
          id="section"
          title={t(ETLCodes.Sections)}
          panel={<ClubAllowedSectionsPage editMode={state === "edit"} clubId={clubId} />}
          disabled={+id <= 0}
        />
        <Tab id="breed" title={t(ETLCodes.Breeds)} panel={<ClubAllowedBreedsPage />} disabled={+id <= 0} />
        <Tab id="file" title={t(ETLCodes.Requests)} panel={<ClubFilePage clubId={clubId} />} disabled={+id <= 0} />
        <Tab
          id="jury"
          title={t(ETLCodes.Jury)}
          panel={<ClubJuryPage clubId={clubId} editMode={state === "edit"} />}
          disabled={+id <= 0}
        />
        {/* <Tab id="contact" title={t(ETLCodes.Contact)} panel={<ClubContactPage clubId={clubId} />} disabled={+id <= 0} /> */}
      </ProtectedTabs>
    </PageBase>
  );
};
